import { AfterViewInit, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import { SimilarMovie } from '../../interfaces/similar-movie-response';
import { Router, ActivatedRoute } from '@angular/router';
import { Movie } from 'src/app/interfaces/cartelera-response';
import { PeliculasService } from 'src/app/services/peliculas.service';
// import * as EventEmitter from 'events';


// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

@Component({
  selector: 'app-slide-peliculas-similares',
  templateUrl: './slide-peliculas-similares.component.html',
  styleUrls: ['./slide-peliculas-similares.component.css']
})
export class SlidePeliculasSimilaresComponent implements OnInit, AfterViewInit {

  @Input () similars: SimilarMovie[] = [];
  @Input () movie!: Movie;
  @Output() enviar: EventEmitter< number > = new EventEmitter< number >();
  public id = 0;

  constructor(  private router: Router  ) { }

  botonClick( id: number ): void {
    this.id = id;
    this.enviar.emit(this.id);
    console.log('desde eventemitter ' + this.id);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const swiper = new Swiper('.swiper1', {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
      // loop: true,
      // grabCursor: true,
      loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-pagination1'
      },
      navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
      },
      scrollbar:{
        el: 'swiper-scrollbar1'
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      },
    });
  }
  onMovieClick( movie: Movie ): void{
    const movieId = movie.id;
    console.log('movie: ' + movieId);
    this.router.navigate(['/pelicula', movieId]);
  }

  goToMovie( id: number ): void{
    this.router.navigate(['/pelicula', id ]);
  }

}
